import { css, keyframes } from '@emotion/react'
import { memo } from 'react'
import { palette } from '../styles/colors'

const rotation = keyframes({
    '0%': {
        rotate: '0deg',
    },
    '100%': {
        rotate: '360deg',
    },
})
const shrink = keyframes({
    '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0',
    },
    '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px',
    },
    '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px',
    },
})

const circularProgressStyles = css({
    display: 'inline-block',
    animation: `${rotation} 1.4s linear infinite`,
    '& svg': {
        backgroundColor: 'transparent',
        color: palette.contrastIcons,
        display: 'block',
        stroke: 'currentColor',
        strokeDasharray: '80px, 200px',
        strokeDashoffset: '0',
    },
})
const shrinkStyles = css({
    animation: `${shrink} 1.4s ease-in-out infinite`,
})

type ProgressProps = {
    disableShrink?: boolean
    size?: number | string
}

const Progress = ({ disableShrink = false, size = 40 }: ProgressProps) => (
    <span
        style={{
            width: size,
            height: size,
        }}
        css={circularProgressStyles}
    >
        <svg viewBox="22 22 44 44">
            <circle
                cx="44"
                cy="44"
                r="20"
                fill="none"
                strokeWidth="3.6"
                css={disableShrink ? null : shrinkStyles}
            />
        </svg>
    </span>
)

export default memo(Progress)
